import { render, staticRenderFns } from "./InvalidAges.vue?vue&type=template&id=710ab31a"
import script from "./InvalidAges.vue?vue&type=script&lang=js"
export * from "./InvalidAges.vue?vue&type=script&lang=js"
import style0 from "./InvalidAges.vue?vue&type=style&index=0&id=710ab31a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports